import React from "react";
import Location from "wxrecall/components/SearchResults/Location";
import moment from "moment";
import PropTypes from "prop-types";

import If from "common/components/if";

/**
 * Renders a metadata cell in the search results table
 */
export default function MetaCell(props) {

  const locations = props.data.type !== 'upperwind' ? props.data.locations.map((l, i) => (
    <Location
      key={`${props.data.type}:${props.data.pk}-${i}-meta`}
      {...l.location}
    />
  )) : '';

  return (
    <div>
      <div>{props.data.translated.type}</div>
      {locations}
      <If condition={props.tab === "bulletin"}>
        <div>{moment(props.data.startValidity).format("MMM DD - H:mm")}</div>
      </If>
    </div>
  );
}

MetaCell.propTypes = {
  // Object representing metadata for this row.
  // Keys include:
  //   - locations [Array] list of locations relevant for this bulletin
  //   - translated [Object] Contains translated string names
  //   - startValidity [Object] A moment object for the start validity of the bulletin.
  //                            Only needed for bulletin recall.
  data: PropTypes.object.isRequired,
  // Which tab are we on, weather or bulletin recall?
  tab: PropTypes.string
};
